import React from "react";

import { UxPreloader, UxPreloaderTypeEnum, UxPriorityEnum } from "@imaginelearning/mps-ux-component-library";
import "./edge-player-preloader.scss";

interface edgePlayerPreloaderProps {
  loadingText?: string;
  loaderType: UxPreloaderTypeEnum;
}

function EdgePlayerPreloader(props: edgePlayerPreloaderProps) {
  const { loadingText, loaderType } = props;
  return (
    <div className="preloader-content">
      <div className="preloader-header" />
      <div className="preloader-type-wrapper align-items-center justify-content-center">
        <span className="loading-text">{loadingText || "Loading..."}</span>
        <UxPreloader
          type={loaderType || UxPreloaderTypeEnum.THREE_DOTS}
          fill={UxPriorityEnum.PRIMARY}
          className="d-flex mx-auto"
        />
      </div>
      <div className="preloader-footer" />
    </div>
  );
}
export default EdgePlayerPreloader;
